// Single source of truth for per-route SEO metadata.
// Used by both the runtime <Seo /> component and the build-time prerender script.
// Keep all branding strictly to Score Integrated Solutions LLC — never mention
// any platform, template, or generic "logistics services" wording.

const SITE = 'https://scoreintegratedsolutions.com';
const OG_IMAGE = `${SITE}/og-image.png`;

const SEO_CONFIG = {
  home: {
    path: '/',
    title: 'Score Integrated Solutions LLC | Technology Support & Sustainment Services',
    description: 'Score Integrated Solutions LLC provides technology support, IT sustainment, cybersecurity support, operational coordination, and mission support services for government and commercial environments.',
    keywords: 'technology support, IT sustainment, cybersecurity support, operational coordination, mission support, government contractor, federal IT services, Score Integrated Solutions',
  },
  about: {
    path: '/about',
    title: 'About Us | Score Integrated Solutions LLC',
    description: 'Score Integrated Solutions LLC is a technology support and sustainment company serving government and enterprise clients with hands-on operational reliability.',
    keywords: 'about Score Integrated Solutions, technology support company, federal contractor, IT sustainment, Rowland Sunday',
  },
  services: {
    path: '/services',
    title: 'Services | Score Integrated Solutions LLC',
    description: 'Technology support, IT sustainment, cybersecurity support, program support, cloud and infrastructure, healthcare IT, and enterprise support services for federal and commercial organizations.',
    keywords: 'IT support services, systems sustainment, cybersecurity services, program support, healthcare IT, cloud support, MHS GENESIS, EHR support',
  },
  government: {
    path: '/government',
    title: 'Government Contracting | Score Integrated Solutions LLC',
    description: 'Federal contracting capabilities for technology support, sustainment, and operational services. Direct experience with the U.S. Army, Defense Health Agency, Department of Veterans Affairs, and Defense Logistics Agency.',
    keywords: 'government contracting, federal contractor, NAICS 541512, subcontracting, defense IT support, DHA, VA, Army IT',
  },
  contact: {
    path: '/contact',
    title: 'Contact Us | Score Integrated Solutions LLC',
    description: 'Contact Score Integrated Solutions LLC to discuss technology support, IT sustainment, cybersecurity support, and operational support services for your organization.',
    keywords: 'contact Score Integrated Solutions, IT support contact, federal contractor inquiry, Richmond VA',
  },
  careers: {
    path: '/careers',
    title: 'Careers | Score Integrated Solutions LLC',
    description: 'Join Score Integrated Solutions LLC. View open positions in technology support, cybersecurity, healthcare IT, systems sustainment, and program support for federal programs.',
    keywords: 'Score Integrated Solutions careers, federal IT jobs, cybersecurity careers, healthcare IT jobs, program support careers, Richmond VA IT jobs',
  },
};

// Lookup by path (used by runtime + prerender).
function lookupByPath(pathname) {
  const normalized = (pathname || '/').replace(/\/+$/, '') || '/';
  const entry = Object.values(SEO_CONFIG).find((e) => e.path === normalized);
  return entry || SEO_CONFIG.home;
}

module.exports = {
  SITE,
  OG_IMAGE,
  SEO_CONFIG,
  lookupByPath,
};
